import React, { Component } from 'react';
import {connect} from "react-redux";
import QuotesTable from "./QuotesTable";
import WorkOrdersTable from "./WorkOrdersTable";
import InvoicesTable from "./InvoicesTable";
import TicklerTable from "./TicklerTable";
import {withRouter} from "react-router-dom";
import {bindActionCreators} from "redux";
import {actionCreators} from "../../../store/LocationDetail";

const scheduled = "scheduled";
const pastWOs = "pastWOs";
const quotes = "quotes";
const invoices = "invoices";


class TabMenu extends Component{

  constructor(props) {
    super(props);
    this.state = {
      active: scheduled
    };
    
    this.handleSelect = this.handleSelect.bind(this);
    this.renderTable = this.renderTable.bind(this);
  }
  
  componentDidMount(){
    // if(this.props.locationDetail.scheduled.length === 0){
    //
    //   this.props.setLocation(this.props.locid);
    //
    // }
    //
    if (this.props.locationDetail.currentLocationId !== this.props.match.params.id ){
    
      this.props.setLocation(this.props.locid);
    
    }
    
    this.setState({
      active: this.props.locationDetail.activeTab
    })
  }
  
  componentWillUnmount(){
    //console.log("TabMenu unmounted");
  };
  
  handleSelect(event){
    let id = event.currentTarget.getAttribute("id");
    this.setState({active: id});
  }
  
  renderTable(){
    let id = this.state.active;
    switch (id) {
      case scheduled:
        return (<TicklerTable/>);
      case pastWOs:
        return (<WorkOrdersTable/>);
      case quotes:
        return (<QuotesTable/>);
      case invoices:
        return (<InvoicesTable />);
    }
  }
  
  render(){
    return(
      <div className="centered-container">
        <div className="container-body">
          <div className="tab-menu">
            <div className="tab-bar">
              <div id="scheduled" onClick={this.handleSelect} className={this.state.active === "scheduled" ? "tab active" : "tab"}>
                Scheduled Services
              </div>
              <div id="pastWOs" onClick={this.handleSelect} className={this.state.active === "pastWOs" ? "tab active" : "tab"}>
                Services
              </div>
              <div id="quotes" onClick={this.handleSelect} className={this.state.active === "quotes" ? "tab active" : "tab"}>
                Quotes
              </div>
              <div id="invoices" onClick={this.handleSelect} className={this.state.active === "invoices" ? "tab active" : "tab"}>
                Invoices
              </div>
            </div>
            <div className="tab-body">
              {this.renderTable()}
            </div>
          </div>
        </div>
      </div>
    );
  }

}

const mapStateToProps = function(state) {
  return {
    user: state.oidc.user,
    current: state.locations.current,
    locationDetail: state.locationDetail
  }
};

export default withRouter(connect(
  mapStateToProps,
  dispatch => bindActionCreators(actionCreators, dispatch)
)(TabMenu));
